import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index.tsx";
import ForageSurface from "./pages/ForageSurface.tsx";
import ForageSouterrain from "./pages/ForageSouterrain.tsx";
import ForageEau from "./pages/ForageEau.tsx";
import Contact from "./pages/Contact.tsx";
import Equipements from "./pages/Equipements.tsx";
import Management from "./pages/Management.tsx";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/forage-surface" element={<ForageSurface />} />
          <Route path="/forage-souterrain" element={<ForageSouterrain />} />
          <Route path="/forage-eau" element={<ForageEau />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/equipements" element={<Equipements />} />
          <Route path="/management" element={<Management />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
